import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { environment } from '../../../../environments/environment';
import { ValidationService } from '../../../shared/providers/validation.service';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../../shared/providers/toast.service';

@Component({
    selector: 'app-matching-listings',
    templateUrl: './matching-listings.component.html',
    styleUrls: ['./matching-listings.component.css']
})
export class MatchingListingsComponent implements OnInit {

    table: DataTableDirective;
    dtOptions = {};
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    constructor(private http: HttpClient, private Toast: ToastService, private Validation: ValidationService, private modalService: BsModalService, private _propertyListingService: PropertyListingService) { }
    protected readonly BASE_URL: string = environment.base_url;

    list = [];
    ngOnInit() {

        const that = this;
        this.dtOptions = {
            pagingType: 'full_numbers',
            serverSide: true,
            processing: true,
            info: false,
            language: {
                zeroRecords: null,
            },
            "order": [0, "asc"],
            "pageLength": 50,
            bLengthChange: false,
            initComplete: () => $('.dataTables_filter').css('display', 'none'),
            ajax: (dataTablesParameters: any, callback: Function) => {
                that.http
                    .post<DataTablesResponse>(
                        this.BASE_URL + '/salesforce/matchingrecordslist',
                        dataTablesParameters, this.Validation.GetAuthHeader()
                    ).subscribe(resp => {
                        that.list = resp.data ? resp.data : [];
                        if (resp) {
                            callback({
                                recordsTotal: resp.recordsTotal,
                                recordsFiltered: resp.recordsFiltered,
                                data: []
                            });
                            if (resp.data.length === 0) {
                                $(".dataTables_paginate.paging_full_numbers").hide();
                            }
                            else {
                                $(".dataTables_paginate.paging_full_numbers").show();
                            }
                            $(".paginate_button.first,.paginate_button.last").hide();
                        } else {
                            callback({
                                recordsTotal: 0,
                                recordsFiltered: 0,
                                data: []
                            });
                            $(".dataTables_paginate.paging_full_numbers").hide();
                        }
                    });
            },
            columns: [
                { data: 'SFOpportunityName' },
                { data: 'SFOpportunityName' },
                { data: 'SFOpportunityName' }]
        };
    }

    showDetails(prospectId: string, i: number) {
        if (this.list[i].Details == undefined || this.list[i].Details.length == 0) {
            this._propertyListingService.getMatchingListings(prospectId).subscribe(res => {
                this.list[i].Details = res;
                this.list[i].showDetails = true;
            });
        }
        else {
            this.list[i].showDetails = !this.list[i].showDetails;
        }
    }

    selectedProspectId = 0;
    selectedPropertyId = 0;
    modalRef: BsModalRef;
    openModalForLinking(template: TemplateRef<any>, classes: any, ProspectId, PropertyId) {
        this.selectedProspectId = ProspectId;
        this.selectedPropertyId = PropertyId;
        this.modalRef = this.modalService.show(template, { class: classes });
    }

    linkPortfolio() {
        this._propertyListingService.LinkPortfolio(this.selectedProspectId, this.selectedPropertyId).subscribe(res => {
            if (res) {
                this.Toast.addToast({ title: 'Success', msg: 'Successfully linked portfolio', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
                this.dtElement.dtInstance.then(x => x.draw());
                this.modalRef.hide();
            }
            else {
                this.Toast.addToast({ title: 'Error Occurred', msg: 'Failed to link portfolio', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
        });
    }
}
